import { apiGet, isOnPath } from './apiWrapper';
import { isNullOrUndefined, updateObject } from './storeFunctions';
import { push } from 'react-router-redux'
import { cloneDeep } from 'lodash';
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value

export const finItem = { 
    value: "", 
    from: "", 
    to: ""     
};

export const emptyFileModel = {
    fileName: "",
    fileBytes: null,
    contentType: null,
    items: null,
    reset: false
}

function emptyExportSectionsModel() {
    return {
        common: {
            order: 0,
            label: "Search.MarketingList.CommonInfo",
            searchTip: null,
            role: null,
            isChecked: true,
            mainNace: true,
            mainNace2: unicornCountry() === 'sk' ? true : null,
            city: true,
            street: true,
            zip: true,
            dic: unicornCountry() === 'sk' ? true : null,
            icDph: true,
            insertedDate: true,
            deletedDate: true,
            identType: true,
            institutionalSector: true,
            registeredCapital: true,
            phone: true,
            mail: true,
            web: true,
            databox: true,
            employeeCategory: true,
            employeeCount: true,
            turnover: true,
            courtFileNumber: true,
            section: unicornCountry() === 'sk' ? true : null,
            registrationCourt: true,
            districtOffice: unicornCountry() === 'sk' ? true : null,
            registry: unicornCountry() === 'sk' ? true : null,
            cribisSemaphore: false,
            warningsInfo: false
        },
        warnings: {
            order: 5,
            label: "Search.MarketingList.WarningAndAdditional",
            searchTip: null,
            role: 'MarketingListWarningsExport',
            warnings: {
                all: [],
                parent: [],
                allSelected: false,
            },
            isChecked: false,
            historical: false,
            details: true,

            additional: {
                all: [],
                parent: [],
                allSelected: false
            },
            sources: {
                all: [],
                parent: [],
                allSelected: false
            },
        },
        financial: {
            order: 6,
            label: "Search.Marketing.FinancialData",
            searchTip: "SearchTips.Unicorn.Config.Financial.Body." + (unicornCountry() === 'sk' ? 'SK' : 'CZ'),
            role: 'MarketingListFinancialExport',
            isChecked: false,
            option: "newest",
            howMany: 0,
            yearFrom: new Date().getFullYear() - 1,
            incorrectStatementFlag: false,
            flagIFRS: false,
            finStatementTypes: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementRows: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementTypesIfrsConsolidated: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementRowsIfrsConsolidated: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementTypesIfrsIndividual: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementRowsIfrsIndividual: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementTypesIfrsOrig: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementRowsIfrsOrig: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementRatios: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementOrganizationsTypes: {
                all: [],
                parent: [],
                allSelected: false
            },
            finStatementOrganizationsRows: {
                all: [],
                parent: [],
                allSelected: false
            }
        },
        relations: {
            order: 3,
            label: "Report.Relations.SectionName",
            searchTip: null,
            role: 'MarketingListRelationsExport',
            isChecked: false,
            allSelected: false,
            historical: false,
            all: [],
            parent: []
        },
        ess: {
            order: 4,
            label: "Search.Marketing.Ess",
            searchTip: null,
            role: 'MarketingListEconomicGroupExport',
            isChecked: false,
            type: "1",
            minShare: 25
        },
        rating: {
            order: 1,
            label: "Report.Ratings.SectionName",
            searchTip: null,
            role: 'MarketingListRatingExport',
            isChecked: false,
            index: false,
            semaphore: false,
            groupSemaphore: false,
            bankruptcy: false,
            creditCapacity: unicornCountry() === 'cz' ? false : null,
            shortTermCreditCapacity: unicornCountry() === 'cz' ? false : null,
            loanLimitPro: unicornCountry() === 'sk' ? false : null,
            loanLimitCons: unicornCountry() === 'sk' ? false : null,
            freeLoanLimitPro: unicornCountry() === 'sk' ? false : null,
            freeLoanLimitCons: unicornCountry() === 'sk' ? false : null,
            paymentDiscipline: unicornCountry() === 'sk' ? false : null
        },
        procurements: {
            order: 9,
            label: "Search.PublicProcurements",
            searchTip: "SearchTips.Unicorn.Config.Extended.Body",
            role: 'MarketingListProcurementsExport',
            isChecked: false,
            from: undefined,
            to: undefined,
            countFrom: "",
            countTo: "",
            sumFrom: "",
            sumTo: ""
        },
        contracts: {
            order: 7,
            label: "Report.PublicContracts.SectionName",
            searchTip: "SearchTips.Unicorn.Config.Extended.Body",
            role: 'MarketingListContractsExport',
            isChecked: false,
            from: undefined,
            to: undefined,
            countFrom: "",
            countTo: "",
            sumFrom: "",
            sumTo: ""
        },
        grants: {
            order: 8,
            label: "Report.Grants.SectionName",
            searchTip: "SearchTips.Unicorn.Config.Extended.Body",
            role: 'MarketingListGrantsExport',
            isChecked: false,
            from: undefined,
            to: undefined,
            countFrom: "",
            countTo: "",
            sumFrom: "",
            sumTo: ""
        },
        activities: {
            order: 2,
            label: "Search.Marketing.Activities",
            searchTip: null,
            role: 'MarketingListActivitiesExport',
            isChecked: false,
            nace: false,
            activities: false,
            trades: false
        },
        msp: {
            order: 10,
            label: "Report.EconomicGroup.StatusEvaluationSectionName",
            searchTip: "SearchTips.Unicorn.Config.TimeSeries.Body",
            role: 'MarketingListExportMsp',
            isChecked: false,
            total: false,
            computedEmployeesCount: false,
            computedTurnover: false,
            computedAssets: false,
            ovm: false,
            partnersCount: false,
            connectedPartners: false,
            connectedPartnersSubjects: false
        },
        timeSeries: {
            order: 11,
            label: "Search.Marketing.Timeseries",
            searchTip: "SearchTips.Unicorn.Config.TimeSeries.Body",
            role: 'MarketingListTimeSeriesExport',
            isChecked: false,
            lastX: 5,
            turnoverCategory: true,
            employeesCategory: true,
            employeesCount: true,
            mainNace: true,
            registeredCapital: true,
            mainNaceRuz: unicornCountry() === 'sk' ? true : null
        },
        vehicles: {
            order: 12,
            label: "Search.Marketing.Vehicles",
            searchTip: null,
            role: 'MarketingListVehiclesExport',
            marketAttribute: 1,
            isChecked: false,
            categories: {
                all: [],
                parent: [],
                allSelected: false
            },
            status: "0",
            registration: new Date().getFullYear() - 1,
            registrationCr: new Date().getFullYear() - 1,
            deRegistration: new Date().getFullYear() - 1,
            leasing: "0"
        },
        premises: {
            order: 13,
            label: "Search.Marketing.Premises",
            searchTip: null,
            role: 'MarketingListPremisesExport',
            isChecked: false,
            actual: true,
            historical: false,
        }
    }
}

function emptySectionsModel() {
    return {
        xlsFileContent: emptyFileModel,
        legalForm: { //pravna forma
            order: 4,
            label: "MarketingList.Common.LegalForm",
            searchTip: null,
            role: null,
            checked: false,
            allSelected: false,
            all: [],
            parent: []
        },
        relationship: { //subjekt podla vazby na zadanu osobu
            order: 15,
            label: "Search.ByRelation.Header",
            searchTip: "SearchTips.Unicorn.SubjectByRelation.Body",
            role: null,
            checked: false,
            fullname: "",
            dob: ""
        },
        addr: { //adresa
            order: 1,
            label: "Search.Common.Address",
            searchTip: "SearchTips.Unicorn.Address.Body",
            role: null,
            checked: false,
            regions: {
                all: [],
                parent: [],
                allSelected: false
            },
            districts: {
                all: [],
                parent: [],
                allSelected: false
            },
            cities: {
                all: [],
                parent: [],
                allSelected: false
            },
            street: '',
            zip: '',
        },
        premises: { //prevadzkarne
            order: 2,
            label: "Search.Marketing.Premises",
            searchTip: null,
            role: 'MarketingListPremisesExport',
            checked: false,
            searchType: 1,
            regions: {
                all: [],
                parent: [],
                allSelected: false
            },
            districts: {
                all: [],
                parent: [],
                allSelected: false
            },
            cities: {
                all: [],
                parent: [],
                allSelected: false
            },
            street: "",
            zip: ""
        },
        contracts: { //zverejnene zmluvy        
            order: 14,
            label: "Report.PublicContracts.SectionName",
            searchTip: "SearchTips.Unicorn.Extended.Body",
            role: null,
            checked: false,
            hasItems: "1",
            direction: '',
            from: "",
            to: "",
            countFrom: undefined,
            countTo: undefined,
            sumFrom: undefined,
            sumTo: undefined,
            currency: ""
        },
        procurements: {//verejne obstaravania
            order: 12,
            label: "Search.PublicProcurements",
            searchTip: "SearchTips.Unicorn.Extended.Body",
            role: null,
            checked: false,
            hasItems: "1",
            direction: '',
            from: "",
            to: "",
            countFrom: undefined,
            countTo: undefined,
            sumFrom: undefined,
            sumTo: undefined,
            currency: "",
        },
        rating: {//hodnotenie subjektu        
            order: 7,
            label: "Report.Ratings.SectionName",
            searchTip: null,
            role: 'MarketingListRatingExport',
            checked: false,
            cribisIndexMin: 10,
            cribisIndexMax: 0,
            semaphores: [1, 2, 3, 4],
            groupSemaphores: [1, 2, 3, 4]
        },
        foreignTrade: {//zahranicny obchod
            order: 16,
            label: "Search.ForeignTrade.Header" + (unicornCountry() === 'sk' ? 'Sk' : 'Cz'),
            searchTip: null,
            role: null,
            checked: false,
            export: {
                all: [],
                parent: [],
                allSelected: false
            },
            import: {
                all: [],
                parent: [],
                allSelected: false
            }
        },
        activity: {//statisticke udaje
            order: 6,
            label: "Search.ActivityScope.Header",
            searchTip: "SearchTips.Unicorn.ActivityScope.Body." + (unicornCountry() === 'sk' ? 'SK' : 'CZ'),
            role: null,
            checked: false,
            nace: {
                all: [],
                parent: [],
                allSelected: false
            },
            naceSource: 'All',
            onlyMainNace: false,
            institutionalSectors: {
                all: [],
                parent: [],
                allSelected: false
            },
            ownerships: {
                all: [],
                parent: [],
                allSelected: false
            },
            turnovers: {
                all: [],
                parent: [],
                allSelected: false
            },
            turnoverYears: {
                all: [],
                parent: [],
                allSelected: false
            },
            employeeRanges: {
                all: [],
                parent: [],
                allSelected: false
            },
            minEmployees: '',
            maxEmployees: ''
        },
        grants: {//dotacie        
            order: 13,
            label: "Report.Grants.SectionName",
            searchTip: "SearchTips.Unicorn.Extended.Body",
            role: null,
            checked: false,
            hasItems: "1",
            direction: '',
            from: "",
            to: "",
            countFrom: undefined,
            countTo: undefined,
            sumFrom: undefined,
            sumTo: undefined,
            currency: ""
        },
        status: {//stav subjektu
            order: 3,
            label: "Search.SubjectStatus.Header",
            searchTip: "SearchTips.Unicorn.SubjectStatus.Body",
            role: null,
            checked: false,
            registrationFrom: '',
            registrationTo: '',
            isVatPayer: '',
            isActive: '1'
        },
        sources: {//zavazky
            order: 10,
            label: "",
            searchTip: null,
            role: null,
            checked: false,
            positive: {
                condition: "OR",
                history: "0",
                all: [],
                parent: [],
                allSelected: false
            },
            negative: {
                condition: "AND",
                history: "0",
                all: [],
                parent: [],
                allSelected: false
            }
        },
        additional: {//doplnujuce info
            order: 9,
            label: "",
            searchTip: null,
            role: null,
            checked: false,
            positive: {
                all: [],
                parent: [],
                condition: "OR",
                history: "0",
                allSelected: false
            },
            negative: {
                all: [],
                parent: [],
                condition: "AND",
                history: "0",
                allSelected: false
            }
        },
        warnings: {//varovne info
            order: 8,
            label: "",
            searchTip: null,
            role: null,
            checked: false,
            positive: {
                all: [],
                parent: [],
                condition: "OR",
                history: "0",
                allSelected: false
            },
            negative: {
                all: [],
                parent: [],
                condition: "AND",
                history: "0",
                allSelected: false
            }
        },
        financial: {//financne udaje
            order: 11,
            label: "Search.Marketing.FinancialData",
            searchTip: "SearchTips.Unicorn.Financial.Body",
            role: null,
            checked: false,
            year: undefined,
            checkLastOnly: true,
            values: {
                values: [],
                condition: "AND",
                currency: unicornCurrency()
            },
            valuesIfrs: {
                values: [],
                condition: "AND"
            },
            valuesIfrsOriginal: {
                values: [],
                condition: "AND"
            },
            ratios: {
                values: [],
                condition: "AND",
            },
            organizationsValues: {
                values: {},
                condition: "AND",
            },
            organizationsTypes: {
                values: [],
                condition: "AND",
            }
        },
        vehicles: { //registrovane vozidla
            order: 17,
            label: "Search.Marketing.Vehicles",
            searchTip: null,
            role: 'MarketingListVehiclesExport',
            marketAttribute: 1,
            checked: false,
            hasItems: "1",
            historyTo: new Date().getFullYear() - 1,
        },
        registeredCapital: {
            order: 5,
            label: "Search.MarketingSection.RegisteredCapital",
            searchTip: "SearchTips.Unicorn.Config.RegisteredCapital.Body",
            role: null,
            checked: false,
            countFrom: undefined,
            countTo: undefined,
        }
    }
}

const apiGetRequests = "ML_GET_REQUESTS";
const apiRequestSuccess = "ML_REQUEST_SUCCESS";
const apiRequestFail = "ML_REQUEST_FAIL";

const apiRequestUpdateInit = "ML_REQUEST_UPDATE_INIT";
const apiRequestUpdateSuccess = "ML_REQUEST_UPDATE_SUCESS";
const apiRequestUpdateFail = "ML_REQUEST_UPDATE_FAIL";

const apiRequestRemoveInit = "ML_REQUEST_REMOVE_INIT";
const apiRequestRemoveSuccess = "ML_REQUEST_REMOVE_SUCESS";
const apiRequestRemoveFail = "ML_REQUEST_REMOVE_FAIL";

const setSections = "SET_SECTIONS";
const uploadFile = "UPLOAD_FILE";
const checkSection = "CHECK_SECTION";
const resetSections = "RESET_SECTION";

const setExportSections = "SET_EXPORT_SECTIONS";
const checkExportSection = "CHECK_EXPORT_SECTION";
const resetExportSections = "RESET_EXPORT_SECTION";

const setPage = "SET_PAGE";
const userLogin = "USER_LOGIN";

const toggleOverview = "TOGGLE_OVERVIEW";

const keys = {
    exportRequests: 'exportRequests',
    updateRequest: 'updateRequest',
    retryRequest: 'retryRequest',
    cloneRequest: 'cloneRequest',
}

export const overviewStates = {
    closed: 'closed',
    overview: 'overview',
    window: 'window',
    rightPanel: 'rightPanel'
}
// Add more when needed
export const unicornSearchStatus = {
    exportPending: 4,
    canceled: 3
};

export const editType = {
    searchParams: 1,
    config: 2,
};

export const expandType = {
    excel: 'e',
    portfolio: 'p',
    both: 'b'
}

const initialState = {
    sections: cloneDeep(emptySectionsModel()),
    exportSections: cloneDeep(emptyExportSectionsModel()),
    searchInProgress: false,
    requests: [],
    //is loading is used when page is initialized or paging clicked
    isLoading: false,
    page: 1,
    pageSize: 50,
    totalCount: 0,
    overviewState: overviewStates.closed,
    overviewRequestId: null,
    overviewExportId: null,
    popupWin: null,
    overviewRequestName: null
}

export const reducer = (state, action) => {
    state = state || Object.assign({}, initialState);

    switch (action.type) {
        case LOCATION_CHANGE:
            return updateObject(state, { location: action.payload.pathname, search: action.payload.search });
        case userLogin:
            return state;
        case setSections:
            return { ...state, sections: action.sections };
        case setExportSections:
            return { ...state, exportSections: action.sections };
        case uploadFile:
            let sc = Object.assign({}, state.sections);
            sc.xlsFileContent = action.file;
            return { ...state, sections: sc };
        case checkSection:
            let s = state.sections;
            //mark checkbox
            s[action.sectionName].checked = action.value;
            return { ...state, sections: s };
        case checkExportSection:
            let es = state.exportSections;
            es[action.sectionName].isChecked = action.value;
            return { ...state, exportSections: es };
        case resetSections:
            var esm = cloneDeep(emptySectionsModel());
            esm.legalForm.checked = true;
            esm.relationship.checked = false;
            esm.addr.checked = true;
            esm.contracts.checked = false;
            esm.procurements.checked = false;
            esm.rating.checked = false;
            esm.foreignTrade.checked = false;
            esm.activity.checked = false;
            esm.grants.checked = false;
            esm.status.checked = true;
            esm.sources.checked = false;
            esm.additional.checked = false;
            esm.warnings.checked = false;
            esm.financial.checked = false;
            return { ...state, sections: esm };
        //whole page loading
        case resetExportSections: {
            return { ...state, exportSections: cloneDeep(emptyExportSectionsModel()) };
        }
        case apiGetRequests:
            return { ...state, isLoading: true, searchInProgress: false };
        //success loading requests    
        case apiRequestSuccess:
            return { ...state, isLoading: false, requests: isNullOrUndefined(action.data) ? null : action.data.data.requests, error: null, totalCount: action.data.data.totalCount, searchInProgress: action.data.data.searchInProgress };
        // failed to laod
        case apiRequestFail:
            return { ...state, isLoading: false, error: action.error, requests: [], searchInProgress: false }
        //request loading
        case apiRequestUpdateInit:
            return { ...state, requests: state.requests.map(x => x.requestId === action.requestId ? Object.assign({}, x, { state: "Loading" }) : x) };
        //request update
        case apiRequestUpdateSuccess:
            return { ...state, requests: state.requests.map(x => x.requestId === action.data.requestId ? action.data : x) };
        //request fail
        case apiRequestUpdateFail:
            return { ...state, requests: state.requests.map(x => x.requestId === action.requestId ? Object.assign({}, x, { state: "Error" }) : x) };

        case apiRequestRemoveInit:
            return { ...state, requests: state.requests.map(x => x.requestId === action.requestId ? Object.assign({}, x, { state: "Loading" }) : x) };
        case apiRequestRemoveSuccess:
            return { ...state, requests: state.requests.filter(x => x.requestId !== action.requestId) };
        case apiRequestRemoveFail:
            return { ...state, requests: state.requests.map(x => x.requestId === action.requestId ? Object.assign({}, x, { state: "Error" }) : x) };

        case setPage:
            return { ...state, page: action.page }
        case toggleOverview:
            return { ...state, overviewState: action.overviewState, overviewRequestId: action.overviewRequestId, overviewExportId: action.overviewExportId, overviewRequestName: action.overviewRequestName, popupWin: action.popupWin}
        // None
        default:
            return state;
    }
}

export const marketingListActions = {
    setSections: (sections) => async (dispatch) => dispatch({ type: setSections, sections: sections }),
    upload: (file) => async (dispatch) => dispatch({ type: uploadFile, file: file }),
    checkSection: (sectionName, value) => async (dispatch) => dispatch({ type: checkSection, sectionName: sectionName, value: value }),
    resetSections: () => async (dispatch) => dispatch({ type: resetSections }),
    setPage: (p) => (dispatch) => dispatch({ type: setPage, page: p }),

    setExportSections: (sections) => async (dispatch) => dispatch({ type: setExportSections, sections: sections }),
    checkExportSection: (sectionName, value) => async (dispatch) => dispatch({ type: checkExportSection, sectionName, value }),
    resetExportSections: () => async (dispatch) => dispatch({ type: resetExportSections }),

    getRequests: (page, pageSize) => async (dispatch) => loadRequests('requests', { page: page, pageSize: pageSize, country: unicornCountry() }, dispatch),
    getTemplates: (page, pageSize) => async (dispatch) => loadRequests('templates', { page: page, pageSize: pageSize, country: unicornCountry() }, dispatch),
    updateRequestStatus: (id, status, exportOrder, exportOrderBy, exportFrom, exportTo, onSuccess) => async (dispatch) => updateRequest(`request/${id}/set-status`, { status: status, exportOrder, exportOrderBy, exportFrom, exportTo }, id, dispatch, onSuccess),
    retryExportRequest: (id) => async (dispatch) => updateRequest(`request/${id}/retry`, {}, id, dispatch),
    repeatExportRequest: (id) => async (dispatch) => updateRequest(`request/${id}/repeat`, {}, id, dispatch),
    cloneExportRequest: (id) => async (dispatch) => updateRequest(`request/${id}/clone`, {}, id, dispatch),
    createTemplateFromRequest: (id, name, onSuccess) => async (dispatch) => updateRequest(`request/${id}/templatize`, { name }, id, dispatch, onSuccess),
    createRequestFromTemplate: (id) => async (dispatch) => updateRequest(`request/${id}/use-template`, {}, id, dispatch, (data) => { 
        if (data.forceEditSearch) {
            dispatch(push(`/unicorn/${unicornCountry()}/parameters?requestId=${data.requestId}&configId=${data.export}&expand=${expandType[data.forceEditSearch.toLowerCase()]}`));
        } else {
            dispatch(push(`/unicorn/${unicornCountry()}/results`)); 
            loadRequests('requests', { country: unicornCountry() }, dispatch); 
        }
    }),
    removeTemplate: (id) => async (dispatch) => removeRequest(`request/${id}/remove-template`, {}, id, dispatch),
    getDefaultSectionData: (name) => () => { return emptySectionsModel()[name] },
    redirectTo: (page) => (dispatch) => dispatch(push(page)),

    toggleMlOverview: (overviewState, overviewRequestId, overviewExportId, overviewRequestName) => (dispatch, getState) => toggleMlOverview(dispatch, getState, overviewState, overviewRequestId, overviewExportId, overviewRequestName)
}

function toggleMlOverview(dispatch, getState, overviewState, overviewRequestId, overviewExportId, overviewRequestName) {
    if (overviewState == overviewStates.window) {
        const url = `/unicorn/overview/${overviewRequestId}/${overviewExportId}`;
        var popupWin = getState().marketingList.popupWin;
        if (popupWin !== null) {
            popupWin.location.assign(url);
            setTimeout(() => {
                popupWin.removeEventListener("beforeunload", () => dispatchClose(dispatch, getState));
                popupWin.addEventListener("beforeunload", () => dispatchClose(dispatch, getState));
            }, 500);
            dispatch({ type: toggleOverview, overviewState, overviewRequestId, overviewExportId, overviewRequestName, popupWin });
        }
        else {
            var popupWin2 = window.open(url, 'MarketingListOverview', `width=1024, height=700, location=no, status=no, toolbar=no, menubar=no, scrollbars=yes, resizable=yes`);
            setTimeout(() => {
                popupWin2.addEventListener("beforeunload", () => dispatchClose(dispatch, getState));
            }, 500);
            dispatch({ type: toggleOverview, overviewState, overviewRequestId, overviewExportId, overviewRequestName, popupWin: popupWin2 });
        }
    }
    else
        dispatch({ type: toggleOverview, overviewState, overviewRequestId, overviewExportId, overviewRequestName, popupWin: null });
}

function dispatchClose(dispatch, getState) {
    dispatch({ type: toggleOverview, overviewState: overviewStates.closed, overviewRequestId: null, overviewExportId: null, popupWin: null });
    loadRequests('requests', { page: getState().marketingList.page - 1, pageSize: getState().marketingList.pageSize, country: unicornCountry() }, dispatch);
}

function getMarketingListUrl(location) {
    return `${window.babylonApiUrl}/api/marketing-list/${location}`;
}

function updateRequest(location, params, requestId, dispatch, onSuccess) {
    dispatch({ type: apiRequestUpdateInit, requestId: requestId });
    apiGet(getMarketingListUrl(location), params,
        res => {
            dispatch({ type: apiRequestUpdateSuccess, data: res.data });
            if (onSuccess)
                onSuccess(res.data);
        },
        err => dispatch({ type: apiRequestUpdateFail, error: err, requestId: requestId })
    );
}

function removeRequest(location, params, requestId, dispatch, onSuccess) {
    dispatch({ type: apiRequestRemoveInit, requestId: requestId });
    apiGet(getMarketingListUrl(location), params,
        res => {
            dispatch({ type: apiRequestRemoveSuccess, requestId: res.data });
            if (onSuccess)
                onSuccess();
        },
        err => dispatch({ type: apiRequestRemoveFail, error: err, requestId: requestId })
    );
}

function loadRequests(location, params, dispatch) {
    dispatch({ type: apiGetRequests, params: params });
    apiGet(getMarketingListUrl(location), params,
        res => dispatch({ type: apiRequestSuccess, data: res }),
        err => dispatch({ type: apiRequestFail, error: err })
    );
}

function unicornCountry() {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return 'cz';
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return 'sk';
    else
        return null;
}

const unicornAttribute = function () {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return 1;
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return 2;
    else
        return null;
}

const unicornAttributes = function () {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return '1,3';
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '2,3';
    else
        return null;
}

const unicornFinValues = function () {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return '40';
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '05|06';
    else
        return null;
}

const unicornFinStatementTypes = function () {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return '00|40';
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '01|02|03|04|05|06';
    else
        return null;
}

const unicornFinStatementOrganizationValues = function () {
    if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '91';
    else
        return null;
}

const unicornFinValuesIfrs = function () {
    if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '51|52|53';
    else
        return null;
}

const unicornFinValuesIfrsConsolidated = function () {
    if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '51';
    else
        return null;
}

const unicornFinValuesIfrsIndividual = function () {
    if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '52|53';
    else
        return null;
}

const unicornFinValuesIfrsOriginal = function () {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return 'XX';    //not used
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return '60|61';
    else
        return null;
}

function unicornCurrency() {
    if (isOnPath({ prefix: '/unicorn/cz/' }))
        return 'CZK';
    else if (isOnPath({ prefix: '/unicorn/sk/' }))
        return 'EUR';
    else
        return null;
}


export { unicornCountry, unicornAttribute, unicornAttributes, unicornFinValues, unicornFinValuesIfrs, unicornFinValuesIfrsConsolidated, unicornFinValuesIfrsIndividual, unicornFinValuesIfrsOriginal, unicornFinStatementTypes, unicornFinStatementOrganizationValues, emptySectionsModel }
